/**
 * 配車計画 配車確定
 */
 import Vue from 'vue'
 import * as httpConst from '../../../../../constants/httpConst'

 const API_PATH = `${httpConst.DRIVER_ENDPOINT}/allocate/entries/dispatches`
 const allocate_entry_dispatch = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    update({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.put(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
  mutations: {},
 }
 export default allocate_entry_dispatch
